export enum RequestFileTypes {
    Default = 0,
    Cover = 1,
}
